import VTable from './index.vue';

export default {
  install: (Vue) => Vue.component('VTable', VTable),
};
